import "./patientModal.css";
import { Modal, Input, Col, Row, Skeleton } from "antd";
import { useContext, useState, useEffect, useCallback, useMemo } from "react";
import { ShowContext } from "../../context/Context";
import { getPatientById } from "../service/fhirAPI";
import { useParamsUrl } from "../../hooks/useParamsUrl";

const PatientModal = (props) => {
  const [patientName, setPatientName] = useState("");
  const [isVisible, setisVisible] = useState(false);
  const [err, setErr] = useState(null);

  useEffect(() => {
    if (err) {
      setTimeout(() => {
        setErr("");
      }, 3000);
    }
  }, [err]);

  const ctx = useContext(ShowContext);

  const similarPatientNames = ctx?.patientData?.entry?.map(
    (item) =>
      item.resource.name[0].given[0] +
      " " +
      item?.resource?.name[0]?.family +
      " " +
      (item?.resource?.gender ? item.resource.gender + " " : "") +
      (item.resource.birthDate ? item.resource.birthDate + " " : "") +
      "(" +
      item.resource.id +
      ")"
  );

  const [paramValue, setSearchParams, removeQueryParams] = useParamsUrl("pid");
  const similarPatientNameId = useMemo(() => {
    return ctx?.patientData?.entry?.map((item) => item.resource.id);
  }, [ctx?.patientData?.entry]);

  const giveId = (idx) => {
    const patientId = similarPatientNameId[idx];
    props.setSummaryPatientName(similarPatientNames[idx]);
    setisVisible(false);
    ctx.giveWholeData(patientId);
    props.close();
  };
  useEffect(() => {
    if (props.summaryPatientName) {
      ctx.setshowPatientName(true);
    } else {
      ctx.setshowPatientName(false);
    }
  }, [ctx, props.summaryPatientName]);

  useEffect(() => {
    if (ctx?.patientData?.entry) {
      setisVisible(true);
    } else {
      setisVisible(false);
    }
  }, [ctx?.patientData?.entry]);

  const handleChange = (event) => {
    setPatientName(event.target.value);
  };

  function searchPatient() {
    ctx.givePatientData(patientName, removeQueryParams);
    ctx.setShow(true);
    setPatientName("");
  }

  const handleIdChange = useCallback(
    (e) => {
      ctx.setPatientId(e.target.value);
    },
    [ctx]
  );

  useEffect(() => {
    const searchSetPatient = async () => {
      if (paramValue) {
        try {
          const data = await getPatientById(paramValue);
          ctx.giveWholeData(data.id);
          ctx.setpatientData(data);
        } catch (error) {
          setErr("No patient found");
        }
      }
    };
    searchSetPatient();
  }, [paramValue]);

  const searchClick = useCallback(async () => {
    try {
      const data = await getPatientById(ctx.patientId);
      setSearchParams({ pid: ctx.patientId }, { replace: true });
      ctx.giveWholeData(data.id);
      ctx.setShow(true);
      ctx.setpatientData(data);
      props.setShowLogin(true);
      ctx.setPatientId("");
      setisVisible(false);
      props.close();
    } catch (error) {
      setErr("No patient found");
    }
  }, [ctx, props]);

  return (
    <>
      <Modal
        open={props.show}
        title="Search For Patient"
        onCancel={props.close}
        style={{ top: 20 }}
        width={900}
        footer={[]}
      >
        <Row>
          <Col span={20}>
            <Input
              className="modalInput"
              onChange={handleChange}
              value={patientName}
              placeholder="Enter Name for Patient Search"
            />
          </Col>
          <Col span={4} className="modalLabel">
            <span onClick={searchPatient}>Search</span>
          </Col>
          {!ctx.isPatientFound && <p>Patient Not Found!</p>}
        </Row>
        <Row>
          <Col span={20}>
            <Input
              className="modalInput"
              placeholder="Enter ID of Patient on this Server"
              onChange={handleIdChange}
              value={ctx.patientId}
            />
          </Col>
          <Col span={4} className="modalLabel">
            <span onClick={searchClick}>Load</span>
          </Col>
          {err && err}
        </Row>
        {/* <Row>
          <Col span={20}>
            <Input
              className="modalInput"
              placeholder="Enter Identifier of Patient"
            />
          </Col>
          <Col span={4} className="modalLabel">
            <span onClick={searchClick}>Search</span>
          </Col>
        </Row> */}
        {ctx.loadingNames ? (
          <Skeleton
            active
            avatar
            paragraph={{ rows: 2 }}
            style={{ width: "30%" }}
          />
        ) : (
          similarPatientNames &&
          isVisible &&
          similarPatientNames.map((item, idx) => (
            <p
              className="patientName"
              key={idx}
              onClick={() => {
                setSearchParams(
                  { pid: similarPatientNameId[idx] },
                  { replace: true }
                );
                giveId(idx);
              }}
            >
              {item}
            </p>
          ))
        )}
      </Modal>
    </>
  );
};

export default PatientModal;
